import React, {useEffect, useRef, useState} from 'react';
import '../../css/web/UserHome.css';
import {Helmet} from "react-helmet-async";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import i18n from '../../i18n';
import axios from '../../services/axiosInstance';
import {BiCaretDown} from "react-icons/bi";
import {FiChevronRight} from "react-icons/fi";
import {FaGooglePlay, FaApple} from "react-icons/fa";
import {isMobile, isTablet} from "react-device-detect";

/* 앱설치 안내 / 쇼핑몰 상품연동 예외팝업 */
import MsgCheckModal from "../../components/web/modal/MsgCheckModal";
import StoreLinkAppPopup from "../../components/web/modal/StoreLinkAppPopup";
import {launchBtorageApp} from "../../services/appLaunch";
import {hasStoreLink} from "../../services/storeLink";

/* 리뉴얼 공용 헤더/푸터 / 리뉴얼되지 않은 우측하단 고정 사이드(유지) / 신규 히어로 배너 */
import UserHeaderRenew from "../../components/web/layoutsuser/UserHeaderRenew";
import UserFooterRenew from "../../components/web/layoutsuser/UserFooterRenew";
import SideQuickMenu from "../../components/web/layoutsuser/SideQuickMenu";
import SectionBanner from "../../components/web/layoutsuser/SectionBanner";

/* 모달 */
import UserMainPopModal from "./UserMainPopModal";

/* 다크/라이트 테마 훅 */
import useTheme from "../../components/web/layoutscommon/DarkModeStorage";

/* 섹션 이미지 */
import mainReviewHeather from '../../assets/img/mainReviewHeather.png';
import mainNoticeHeather from '../../assets/img/mainNotice.png';
import mainFaqHeather from '../../assets/img/mainFaq.png';
import CenterImg from '../../assets/img/CenterIcon.png';
import LookupImg from '../../assets/img/LookupImage.png';
import noData from '../../assets/img/noData.png';
import noReviewPhoto from "../../assets/img/btorage_noimage.png";

import btoragePay from '../../assets/img/btorageBooster.png';
import creditCard from '../../assets/img/payFormHeader.png';
import PaypalLogo from '../../assets/img/PaypalLogo.png';
import WireBarleyLogo from '../../assets/img/WireBarleyLogo.png';
import SentbeLogo from '../../assets/img/SentbeLogo.png';
import StripeLogo from '../../assets/img/StripeLogo.png';
import TransferWiseLogo from '../../assets/img/TransferWiseLogo.png';
import AlipayLogo from '../../assets/img/AlipayLogo.png';
import WechatPayLogo from '../../assets/img/WechatPayLogo.png';
import commonEtc from '../../assets/img/commonEtc.png';
import FedexLogo from '../../assets/img/FedexLogo.png';
import EmsLogo from '../../assets/img/EmsLogo.png';
import UpsLogo from '../../assets/img/UpsLogo.png';
import Kpacket from '../../assets/img/Kpacket.png';
import SmallPacket from "../../assets/img/commonSmallPacket.png";
import SeaShipLogo from '../../assets/img/SeaShipLogo.png';

/*
 * UserHome
 * - 헤더/섹션/푸터를 하나로 통합한 홈화면. 헤더는 공용 컴포넌트(UserHeaderRenew)로 분리.
 * - 배송조회/후기/공지/FAQ 등 섹션 로직은 기존 SectionMain 과 동일하게 유지, UI만 리뉴얼.
 * - 우측하단 고정 SideQuickMenu 는 리뉴얼 없이 그대로 유지.
 */
function UserHome() {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const [theme, themeToggler] = useTheme();

    const SSAT = sessionStorage.getItem('AToken');
    const LCAT = localStorage.getItem('AToken');

    /** ══════════════════════════════════════════════════════════════════════
     *  [구매대행 API] 앱 설치 버튼 (Android / iOS 어떤 버튼을 눌러도 동일 동작)
     *  ─────────────────────────────────────────────────────────────────────
     *   웹(PC)     : UserLoginPg.js 와 동일하게 앱설치 안내 팝업 노출
     *   웹(Mobile) : MLoginPg.js 의 handleAppLaunch() 와 동일하게 기기별 스토어/딥링크 실행
     *   예외       : 쇼핑몰 상품데이터가 연동/보관된 상태면 안내팝업을 먼저 노출한다.
     *  ══════════════════════════════════════════════════════════════════════ */
    const [appLaunchMsg, setAppLaunchMsg] = useState(false);
    const [storeLinkAppMsg, setStoreLinkAppMsg] = useState(false);
    const closeAppLaunchMsg = () => setAppLaunchMsg(false);

    /** 실제 앱설치/실행 동작 (PC는 안내팝업, 모바일은 스토어 이동) */
    const runAppLaunch = () => {
        if (isMobile || isTablet) launchBtorageApp();
        else setAppLaunchMsg(true);
    };

    const handleAppLaunch = () => {
        if (hasStoreLink()) {
            setStoreLinkAppMsg(true);
            return;
        }
        runAppLaunch();
    };

    /* ---- 이용후기 ---- */
    const [reviewAllList, setReviewAllList] = useState([]);
    const selectReviewAllList = () =>
        axios({method: 'get', url: '/review/selectReviewAllList', headers: {Authorization: LCAT ? LCAT : SSAT}})
            .then((response) => setReviewAllList(response.data.sort((a, b) => b.seqNum - a.seqNum)));

    /* ---- 배송조회 (기능 그대로) ---- */
    const [selectedShipco, setSelectedShipco] = useState('');
    const [overseasShipcoList, setOverseasShipcoList] = useState([]);
    const [selectedDomestic, setSelectedDomestic] = useState('');
    const [domesticShipcoList, setDomesticShipcoList] = useState([]);
    const [osTrackNum, setOsTrackNum] = useState('');
    const [dsTrackNum, setDsTrackNum] = useState('');

    const bringToOverseasShipCo = () => axios({method: 'get', url: '/shipcompany/bringToShipCo/1'})
        .then((response) => setOverseasShipcoList(response.data));
    const bringToDomesticShipCo = () => axios({method: 'get', url: '/shipcompany/bringToShipCo/0'})
        .then((response) => setDomesticShipcoList(response.data));

    const [shipcoShow, setShipcoShow] = useState(false);
    const shipcoRef = useRef(null);
    const toggleShipcoShow = () => setShipcoShow(!shipcoShow);
    const handleShipcoChange = (shipco) => { setSelectedShipco(shipco); setShipcoShow(false); };

    const [domesticShow, setDomesticShow] = useState(false);
    const domesticRef = useRef(null);
    const toggleDomesticShow = () => setDomesticShow(!domesticShow);
    const handleDomesticChange = (domestic) => { setSelectedDomestic(domestic); setDomesticShow(false); };

    useEffect(() => {
        function handleClickOutside(event) {
            if (shipcoRef.current && !shipcoRef.current.contains(event.target)) setShipcoShow(false);
            if (domesticRef.current && !domesticRef.current.contains(event.target)) setDomesticShow(false);
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleOsTrackNum = (e) => setOsTrackNum(e);
    const handleDsTrackNum = (e) => setDsTrackNum(e.replace(/\D/g, ''));

    const selectOsTrackNum = () => {
        const width = 1200, height = 800;
        const left = (window.screen.width / 2) - (width / 2);
        const top = (window.screen.height / 2) - (height / 2);
        const opt = `width=${width},height=${height},left=${left},top=${top}`;
        if (selectedShipco === "FedEx" || selectedShipco === "FedEx-E") {
            window.open(`https://www.fedex.com/fedextrack/?trknbr=${osTrackNum}`, '_blank', opt);
        } else if (selectedShipco === "UPS" || selectedShipco === "UPS-E") {
            window.open(`https://www.ups.com/track?loc=ko_KR&trackNums=${osTrackNum}&requester=ST/trackdetails`, '_blank', opt);
        } else if (selectedShipco === "DHL") {
            window.open(`https://www.dhl.com/kr-ko/home/tracking/tracking-ecommerce.html?submit=1&tracking-id=${osTrackNum}`, '_blank', opt);
        } else if (selectedShipco === "EMS" || selectedShipco === "SEA" || selectedShipco === "K-Packet" || selectedShipco === "Small-Packet" || selectedShipco === "EMSP") {
            window.open(`https://service.epost.go.kr/trace.RetrieveEmsRigiTraceList.comm?POST_CODE=${osTrackNum}&displayHeader=N`, '_blank', opt);
        }
    };

    const selectDsTrackNum = () => {
        const width = 1200, height = 800;
        const left = (window.screen.width / 2) - (width / 2);
        const top = (window.screen.height / 2) - (height / 2);
        const opt = `width=${width},height=${height},left=${left},top=${top}`;
        if (selectedDomestic === "CJ대한통운" || selectedDomestic === "CJ 대한통운") {
            window.open(`https://trace.cjlogistics.com/next/tracking.html?wblNo=${dsTrackNum}`, '_blank', opt);
        } else if (selectedDomestic === "로젠택배") {
            window.open(`https://www.ilogen.com/web/personal/trace/${dsTrackNum}`, '_blank', opt);
        } else if (selectedDomestic === "우체국") {
            window.open(`https://service.epost.go.kr/trace.RetrieveDomRigiTraceList.comm?sid1=${dsTrackNum}&displayHeader=N`, '_blank', opt);
        } else if (selectedDomestic === "한진택배") {
            window.open(`https://www.hanjin.com/kor/CMS/DeliveryMgr/WaybillResult.do?mCode=MN038&schLang=KR&wblnumText2=${dsTrackNum}`, '_blank', opt);
        } else if (selectedDomestic === "롯데택배") {
            window.open(`https://www.lotteglogis.com/open/tracking?invno=${dsTrackNum}`, '_blank', opt);
        } else if (selectedDomestic === "경동택배") {
            window.open(`https://kdexp.com/newDeliverySearch.kd?barcode=${dsTrackNum}`, '_blank', opt);
        }
    };

    /* ---- 공지 / FAQ ---- */
    const [noticeList, setNoticeList] = useState([]);
    const [faqDtList, setFaqDtList] = useState([]);

    const selectAllNoticeList = (lang) => axios({method: 'get', url: '/notice/findLatestByLang/', params: {limit: 10, lang}})
        .then((response) => setNoticeList(response.data.sort((a, b) => b.seqNum - a.seqNum)));
    const selectFixFirstCondition = (lang) => axios({method: 'get', url: '/faq/selectFixFirstCondition/', params: {limit: 10, lang}})
        .then((response) => setFaqDtList(response.data.sort((a, b) => b.seqNum - a.seqNum)));

    const moveToNoticeDtPg = (seqNum) => navigate(`/UserNoticeDtPg/${seqNum}`);
    const moveToFaqDtPg = (seqNum) => navigate(`/UserFaqDtPg/${seqNum}`);

    /* ---- 공통 유틸 ---- */
    const formatDate = (dateStr) => {
        if (!dateStr || dateStr.length !== 8) return "";
        return `${dateStr.substring(0, 4)}-${dateStr.substring(4, 6)}-${dateStr.substring(6, 8)}`;
    };
    const newTextPrintFl = (regDate) => {
        if (!regDate || regDate.length !== 8) return false;
        const postDate = new Date(parseInt(regDate.substring(0, 4), 10), parseInt(regDate.substring(4, 6), 10) - 1, parseInt(regDate.substring(6, 8), 10));
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const diffDays = (today.getTime() - postDate.getTime()) / (1000 * 60 * 60 * 24);
        return diffDays >= 0 && diffDays < 3;
    };

    /* ---- 로드 & 언어별 데이터 ---- */
    useEffect(() => {
        selectReviewAllList();
        bringToOverseasShipCo();
        bringToDomesticShipCo();
    }, []);

    useEffect(() => {
        const handleLanguageChange = (lng) => {
            let lang;
            switch (lng) {
                case 'en': lang = '1'; break;
                case 'ja': lang = '2'; break;
                case 'zh': lang = '3'; break;
                case 'id': lang = '4'; break;
                default: lang = '0';
            }
            selectAllNoticeList(lang);
            selectFixFirstCondition(lang);
        };
        handleLanguageChange(i18n.language);
        i18n.on('languageChanged', handleLanguageChange);
        return () => i18n.off('languageChanged', handleLanguageChange);
    }, []);

    const payLogos = [btoragePay, creditCard, PaypalLogo, WireBarleyLogo, SentbeLogo, StripeLogo, TransferWiseLogo, AlipayLogo, WechatPayLogo, commonEtc];
    const shipLogos = [FedexLogo, UpsLogo, SmallPacket, EmsLogo, Kpacket, SeaShipLogo];

    return (
        <div className="uh-root" data-theme={theme}>
            <Helmet>
                <title>비토리지(Btorage) | 한국상품 전세계로 역구매/배송대행</title>
                <meta name="description" content="[한국에서 전세계로] 한국의 모든 상품을 구매 후 해외배송 대행해드립니다. 실시간채팅, BtoragePay, 국내/해외카드 등 다양한 결제수단과 다양한 해외배송사 비교견적을 통해 편리하고 빠르게 주문해보세요 :)"/>
                <link rel="canonical" href="https://btorage.com/"/>
                <meta property="og:url" content="https://btorage.com/"/>
                <meta property="og:type" content="website"/>
                <meta property="og:image" content="https://btorage.com/linkBanner.jpg"/>
                <meta property="og:site_name" content="비토리지(Btorage)"/>
            </Helmet>

            {/* ===================== 헤더 ===================== */}
            <UserHeaderRenew theme={theme} themeToggler={themeToggler}/>

            {/* ===================== 메인 ===================== */}
            <main className="uh-main">
                {/* 배너 */}
                <SectionBanner/>

                {/* ===== [구매대행 API] 앱 설치 유도 ===== */}
                <section className="uh-section">
                    <div className="uh-appcta">
                        {/* 좌우 대칭 글로우 — 한쪽으로 색이 쏠리지 않도록 양쪽에 은은하게 깐다 */}
                        <span className="uh-appcta-glow uh-appcta-glow-l" aria-hidden="true"/>
                        <span className="uh-appcta-glow uh-appcta-glow-r" aria-hidden="true"/>

                        <div className="uh-appcta-inner">
                            <span className="uh-appcta-badge">MOBILE APP</span>

                            <img className="uh-appcta-logo" src={btoragePay} alt="Btorage"/>

                            <h3 className="uh-appcta-title">{t('homeAppTitle')}</h3>
                            <p className="uh-appcta-desc">{t('homeAppDesc')}</p>

                            {/* Android / iOS 버튼은 디자인·배경·효과를 완전히 동일하게 사용한다 */}
                            <div className="uh-appcta-btns">
                                <button type="button" className="uh-appcta-bt" onClick={handleAppLaunch}>
                                    <FaGooglePlay size={16}/><span>{t('homeAppAos')}</span>
                                </button>
                                <button type="button" className="uh-appcta-bt" onClick={handleAppLaunch}>
                                    <FaApple size={18}/><span>{t('homeAppIos')}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </section>

                {/* 이용후기 */}
                <section className="uh-section">
                    <div className="uh-section-head">
                        <div className="uh-sec-ico"><img src={mainReviewHeather} alt="" style={{width: 24, height: 24}}/></div>
                        <h2>{t("smHeader")}</h2>
                        <button className="uh-more" onClick={() => navigate("/UserReviewPg")}>More <FiChevronRight style={{verticalAlign: "middle"}}/></button>
                    </div>
                    {reviewAllList.length > 0 ?
                        <div className="uh-review-grid">
                            {reviewAllList.slice(0, 8).map((review, index) => {
                                const hasPhoto = review && review.reviewPhotoDTO[0] && review.reviewPhotoDTO[0].fileNm;
                                return (
                                    <div key={index} className="uh-review" onClick={() => navigate(`/UserReviewDetailPg/${review.seqNum}`)}>
                                        <div className={`uh-review-thumb ${hasPhoto ? "" : "is-empty"}`}>
                                            {newTextPrintFl(review.regDate) && <span className="uh-review-new">New</span>}
                                            {hasPhoto ?
                                                <img alt="" src={"https://toeloperfile.s3.ap-northeast-2.amazonaws.com/reviewPhoto/" + review.reviewPhotoDTO[0].fileNm}/>
                                                :
                                                <img alt="" src={noReviewPhoto}/>
                                            }
                                        </div>
                                        <div className="uh-review-body">
                                            <p className="uh-review-tag">[{review.country}-{review.shipco}]</p>
                                            <p className="uh-review-title">{review.title}</p>
                                            <p className="uh-review-date">{formatDate(review.regDate)}</p>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        :
                        <div className="uh-nodata"><img src={noData} alt="no data"/><p>No Data</p></div>
                    }
                </section>

                {/* 공지 / FAQ */}
                <section className="uh-section">
                    <div className="uh-two-col">
                        <div>
                            <div className="uh-section-head">
                                <div className="uh-sec-ico"><img src={mainNoticeHeather} alt="" style={{width: 22, height: 22}}/></div>
                                <h2>{t("smNotice")}</h2>
                                <button className="uh-more" onClick={() => navigate("/UserNoticePg")}>More <FiChevronRight style={{verticalAlign: "middle"}}/></button>
                            </div>
                            <div className="uh-card uh-list">
                                {noticeList && noticeList.map((notice, i) => (
                                    <div key={i} className="uh-list-row" onClick={() => moveToNoticeDtPg(notice?.seqNum)}>
                                        <span className="uh-list-title">{notice?.title}</span>
                                        {newTextPrintFl(notice?.regDate) && <span className="uh-list-new">New</span>}
                                        <span className="uh-list-date">{formatDate(notice?.regDate)}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div>
                            <div className="uh-section-head">
                                <div className="uh-sec-ico"><img src={mainFaqHeather} alt="" style={{width: 22, height: 22}}/></div>
                                <h2>{t("smFaq")}</h2>
                                <button className="uh-more" onClick={() => navigate("/UserFaqPg")}>More <FiChevronRight style={{verticalAlign: "middle"}}/></button>
                            </div>
                            <div className="uh-card uh-list">
                                {faqDtList && faqDtList.map((faq, i) => (
                                    <div key={i} className="uh-list-row" onClick={() => moveToFaqDtPg(faq?.seqNum)}>
                                        <span className="uh-list-title"><span className="uh-list-cat">[{faq?.faqMstDTO?.title}]</span>{faq?.title}</span>
                                        <span className="uh-list-date">{formatDate(faq?.regDate)}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>

                {/* 물류센터 / 배송조회 */}
                <section className="uh-section">
                    <div className="uh-info-grid">
                        {/* 물류센터 */}
                        <div className="uh-card uh-info-card">
                            <div className="uh-info-ico"><img src={CenterImg} alt=""/></div>
                            <div className="uh-info-title">{t("smCenter")}</div>
                            <div className="uh-info-line">
                                <div>{t("smZipcode")}</div>
                                <div>{t("smAddress")} : 경기도 광주시 곤지암읍 연곡길42번길 32-15</div>
                                <div>{t("smTell")}</div>
                                <div>{t("smMailbox")}</div>
                            </div>
                            <div className="uh-info-cta">
                                <button className="uh-btn uh-btn-primary" onClick={() => navigate("/UserPickupRequestPg")}>{t("smPickupBt")}</button>
                            </div>
                        </div>

                        {/* 배송조회 (기능 그대로, UI 리팩토링) */}
                        <div className="uh-card uh-info-card uh-info-card-track">
                            <div className="uh-info-ico"><img src={LookupImg} alt=""/></div>
                            <div className="uh-info-title">{t("smTrackHeader")}</div>
                            <div className="uh-info-line">{t("smTrackContent1")}</div>
                            <div className="uh-track">
                                {/* 국제배송 */}
                                <div className="uh-track-row">
                                    <div className="uh-select" ref={shipcoRef}>
                                        <button className="uh-select-btn" onClick={toggleShipcoShow}>
                                            <span className={selectedShipco === "" ? "ph" : ""}>{selectedShipco === "" ? t("ordOsDvLabel") : selectedShipco}</span>
                                            <BiCaretDown/>
                                        </button>
                                        {shipcoShow &&
                                            <div className="uh-select-list">
                                                {overseasShipcoList.filter(s => s !== "국내배송").map((shipco, index) => (
                                                    <div className="uh-select-opt" key={index} onClick={() => handleShipcoChange(shipco)}>{shipco}</div>
                                                ))}
                                            </div>
                                        }
                                    </div>
                                    <div className="uh-track-input">
                                        <input value={osTrackNum} onChange={(e) => handleOsTrackNum(e.target.value)}
                                               onKeyDown={(e) => { if (e.key === 'Enter') selectOsTrackNum(); }}/>
                                        <button className="uh-track-enter" onClick={selectOsTrackNum}>Enter</button>
                                    </div>
                                </div>
                                {/* 국내배송 */}
                                <div className="uh-track-row">
                                    <div className="uh-select" ref={domesticRef}>
                                        <button className="uh-select-btn" onClick={toggleDomesticShow}>
                                            <span className={selectedDomestic === "" ? "ph" : ""}>{selectedDomestic === "" ? t("ordDsDvLabel") : selectedDomestic}</span>
                                            <BiCaretDown/>
                                        </button>
                                        {domesticShow &&
                                            <div className="uh-select-list">
                                                {domesticShipcoList.filter(d => d !== "기타택배" && d !== "쿠팡").map((domestic, index) => (
                                                    <div className="uh-select-opt" key={index} onClick={() => handleDomesticChange(domestic)}>{domestic}</div>
                                                ))}
                                            </div>
                                        }
                                    </div>
                                    <div className="uh-track-input">
                                        <input value={dsTrackNum} onChange={(e) => handleDsTrackNum(e.target.value)}
                                               onKeyDown={(e) => { if (e.key === 'Enter') selectDsTrackNum(); }}/>
                                        <button className="uh-track-enter" onClick={selectDsTrackNum}>Enter</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* 결제수단 / 배송사 */}
                <section className="uh-section">
                    <div className="uh-info-grid">
                        {/* 결제수단 */}
                        <div className="uh-card uh-info-card">
                            <div className="uh-logo-wrap">
                                {payLogos.map((logo, i) => (
                                    <div className="uh-logo-chip" key={i}><img src={logo} alt="pay"/></div>
                                ))}
                            </div>
                            <div className="uh-info-title">{t("smPayty")}</div>
                            <div className="uh-info-line">Paypal, WireBarley, Sentbe, TransferWise, Stripe, Alipay, Wechatpay, {t("smPaytyContent")}</div>
                            <div className="uh-info-cta">
                                <button className="uh-btn uh-btn-primary" onClick={() => navigate("/UserOrderPg", {state: {orderState: true, headerText: t("hdSMenu6")}})}>{t("smPaytyBt")}</button>
                            </div>
                        </div>
                        {/* 배송사 */}
                        <div className="uh-card uh-info-card">
                            <div className="uh-logo-wrap">
                                {shipLogos.map((logo, i) => (
                                    <div className="uh-logo-chip" key={i}><img src={logo} alt="ship"/></div>
                                ))}
                            </div>
                            <div className="uh-info-title">{t("smShipcoHeader")}</div>
                            <div className="uh-info-line">
                                <div>{t("smShipcoContent1")}</div>
                                <div>{t("smShipcoContent2")}</div>
                            </div>
                            <div className="uh-info-cta">
                                <button className="uh-btn uh-btn-primary" onClick={() => navigate("/UserCompareShipPg")}>{t("smShipcoBt")}</button>
                            </div>
                        </div>
                    </div>
                </section>
            </main>

            {/* ===================== 푸터 (공용 리뉴얼 푸터) ===================== */}
            <UserFooterRenew/>

            {/* 우측하단 고정 사이드 (리뉴얼 없이 유지) */}
            <SideQuickMenu/>

            {/* 메인 팝업 모달 */}
            <UserMainPopModal/>

            {/* [구매대행 API] 웹(PC) 앱설치 안내팝업 (UserLoginPg.js 와 동일) */}
            {appLaunchMsg &&
                <MsgCheckModal appLaunchMsg={appLaunchMsg} closeAppLaunchMsg={closeAppLaunchMsg}/>
            }

            {/* [구매대행 API] 쇼핑몰 상품데이터 연동상태에서 앱설치 클릭 시 예외 안내팝업 */}
            {storeLinkAppMsg &&
                <StoreLinkAppPopup
                    theme={theme}
                    onInstall={() => {
                        setStoreLinkAppMsg(false);
                        runAppLaunch();
                    }}
                    onClose={() => setStoreLinkAppMsg(false)}/>
            }
        </div>
    );
}

export default UserHome;
